function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATED BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import BorderlessTableOutlinedSvg from '@ant-design/icons-svg/lib/asn/BorderlessTableOutlined';
import AntdIcon from "../components/AntdIconLight";
const BorderlessTableOutlined = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: BorderlessTableOutlinedSvg
}));

/**![borderless-table](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExNyAzNjhoMjMxdjY0SDExN3ptNTU5IDBoMjQxdjY0SDY3NnptLTI2NCAwaDIwMHY2NEg0MTJ6bTAgMjI0aDIwMHY2NEg0MTJ6bTI2NCAwaDI0MXY2NEg2NzZ6bS01NTkgMGgyMzF2NjRIMTE3em0yOTUtMTYwVjE3OWgtNjR2NjY2aDY0VjU5MnptMjY0LTY0VjE3OWgtNjR2NjY2aDY0VjQzMnoiIC8+PC9zdmc+) */
const RefIcon = /*#__PURE__*/React.forwardRef(BorderlessTableOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BorderlessTableOutlined';
}
export default RefIcon;